<template>
  <div :key="componentKey" class="block visitor">
    <div class="row" style="display: flex; align-items: center">
      <div class="col-md-6">
        <div class="avatar-space">
          <avatar-input
            v-if="showAvatar"
            :visitor="visitor"
            :errors="errors"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :form="form"
            class="pull-left"
          />
          <div class="col-md-12 avatar-error-text">
            <error-help-block v-if="showAvatarErrorBlock" current-error="Загрузите фотографию посетителя" />
          </div>
        </div>
        <full-name-title
          :visitor-name="visitorName"
          :visitor-personal="visitorPersonal"
          :errors="errors"
          :visitor="visitor"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
        />
      </div>
      <visitor-form-menu
        :visitor-personal="visitorPersonal"
        :visitor-index="visitorIndex"
        :transport-index="transportIndex"
        :visitor="visitor"
        :cfg-menu-visitor="cfgMenuVisitor"
        :is-single-visitor="isSingleVisitor"
        :approve-form="approveForm"
        :form="form"
        :menu-not-empty="visitorFormMenuNotEmpty"
      />
      <div v-if="(isView === false || isDuplicate) && canRemoveVisitor" class="col-md-6">
        <button
          type="button"
          class="btn btn-default pull-right delete-btn visitors-control-btn"
          style="margin-right: 0"
          @click="removeVisitor"
        >Удалить
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <last-name-input
          v-model="visitorPersonal.fullname_last"
          :key="visitorIndex"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
          :visitor="visitor"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadLastName"
          :select-typeahead="selectTypeaheadLastName"
          :disabled="disabledLastName"
          @change="changeLastName"
          @loaded-typehead="setTabindex"
        />
      </div>
      <div class="col-md-4">
        <first-name-input
          v-model="visitorPersonal.fullname_first"
          :key="visitorIndex"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
          :visitor="visitor"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadFirstName"
          :select-typeahead="selectTypeaheadFirstName"
          :disabled="disabledFirstName"
          @change="changeFirstName"
          @loaded-typehead="setTabindex"
        />
      </div>
      <div class="col-md-4">
        <patronymic-name-input
          v-model="visitorPersonal.fullname_patronymic"
          :key="visitorIndex"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
          :visitor="visitor"
          :form="form"
          :errors="errors"
          :typeahead="typeaheadPatronymicName"
          :disabled="disabledPatronymicName"
          @change="change"
          @loaded-typehead="setTabindex"
        >
          <div slot="after">
            <div v-if="nameAndSurnameSame" class="help-block error-text">
              Фамилия и отчество не могут быть одинаковыми
            </div>
            <label class="applicant-helpers flex-label">
              <input
                v-model="visitorPersonal.patronymic_missing"
                :disabled="disabledPatronymicMissing"
                type="checkbox"
                @change="changePatronymic"
              />
              &nbsp;
              Отсутствует
            </label>
          </div>
        </patronymic-name-input>
      </div>
    </div>
    <div class="row">
      <div
        v-if="fieldVisible(PassSectionFieldAliases.BIRTHDAY, PassSectionsEnum.visitors)"
        :class="'col-md-' + fieldWidth(PassSectionFieldAliases.BIRTHDAY)"
      >
        <birthday-input
          v-model="visitorPersonal.birthday"
          :input-label="fieldTitle(PassSectionFieldAliases.BIRTHDAY)"
          :input-hint="fieldHint(PassSectionFieldAliases.BIRTHDAY)"
          :key="visitorIndex"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
          :visitor="visitor"
          :form="form"
          :errors="errors"
          :disabled="disabledBirthday"
          :min-date="minMomentDate.clone()"
          :max-date="currentMomentDate.clone()"
          :timezone="timezone"
          @change="emitChangeDate"
        />
      </div>
      <div
        v-if="fieldVisible(PassSectionFieldAliases.PLACEBIRTH, PassSectionsEnum.visitors)"
        :class="'col-md-' + fieldWidth(PassSectionFieldAliases.PLACEBIRTH)"
      >
        <placebirth-input
          v-model="visitorPersonal.placebirth"
          :input-label="fieldTitle(PassSectionFieldAliases.PLACEBIRTH)"
          :input-hint="fieldHint(PassSectionFieldAliases.PLACEBIRTH)"
          :key="visitorIndex"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
          :visitor="visitor"
          :form="form"
          :errors="errors"
          :disabled="disabledPlacebirth"
          @change="change"
          ref="placebirth"
        />
      </div>
      <div
        v-if="fieldVisible(PassSectionFieldAliases.NATIONALITY, PassSectionsEnum.visitors)"
        :class="'col-md-' + fieldWidth(PassSectionFieldAliases.NATIONALITY)"
      >
        <nationality-input
          v-model="visitorPersonal.nationality_id"
          :input-label="fieldTitle(PassSectionFieldAliases.NATIONALITY)"
          :input-hint="fieldHint(PassSectionFieldAliases.NATIONALITY)"
          :key="visitorIndex"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
          :visitor="visitor"
          :form="form"
          :errors="errors"
          :items="allowedNationalities"
          :disabled="disabledNationality"
          @input="changeNationality"
        />
      </div>
    </div>
    <div class="row">
      <div
        v-if="fieldVisible(PassSectionFieldAliases.IDENTIFICATION_DOCUMENT, PassSectionsEnum.visitors)"
        :class="'col-md-' + fieldWidth(PassSectionFieldAliases.IDENTIFICATION_DOCUMENT)"
      >
        <identification-document-input
          v-model="visitorPersonal.identification_id"
          :input-label="fieldTitle(PassSectionFieldAliases.IDENTIFICATION_DOCUMENT)"
          :input-hint="fieldHint(PassSectionFieldAliases.IDENTIFICATION_DOCUMENT)"
          :key="visitorIndex"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
          :visitor="visitor"
          :form="form"
          :errors="errors"
          :items="calculatedPersonalIdentifications"
          :disabled="disabledIdentificationDocument"
          @change="changePassport"
        />
      </div>
      <div
        v-if="fieldVisible(PassSectionFieldAliases.IDENTIFICATION_NUMBER, PassSectionsEnum.visitors)"
        :class="'col-md-' + fieldWidth(PassSectionFieldAliases.IDENTIFICATION_NUMBER)"
      >
        <identification-number-input
          v-model="visitorPersonal.identification_number"
          :input-label="fieldTitle(PassSectionFieldAliases.IDENTIFICATION_NUMBER)"
          :input-hint="fieldHint(PassSectionFieldAliases.IDENTIFICATION_NUMBER)"
          :key="visitorIndex"
          :visitor-index="visitorIndex"
          :transport-index="transportIndex"
          :document-masks="documentMasks"
          :visitor="visitor"
          :warning-message="visitorPersonal.visitorErr"
          :form="form"
          :errors="errors"
          :disabled="disabledIdentificationNumber"
          @change="change"
          @blur="blurIdentificationNumber;checkIdentificationNumber"
          @input="checkIdentificationNumber"
        />
      </div>
      <div
        v-if="fieldVisible(PassSectionFieldAliases.IDENTIFICATION_DATE_OF, PassSectionsEnum.visitors)"
        :class="'col-md-' + fieldWidth(PassSectionFieldAliases.IDENTIFICATION_DATE_OF)"
      >
        <template>
          <identification-date-of-input
            v-model="visitorPersonal.identification_date_of"
            :input-label="fieldTitle(PassSectionFieldAliases.IDENTIFICATION_DATE_OF)"
            :input-hint="fieldHint(PassSectionFieldAliases.IDENTIFICATION_DATE_OF)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :form="form"
            :errors="errors"
            :disabled="disabledIdentificationDateOf"
            :min-date="minMomentDate.clone()"
            :max-date="currentMomentDate.clone()"
            @change="emitChangeDate"
            @blur="checkIdentificationNumber"
            @input="checkIdentificationNumber"
          />
        </template>
      </div>
    </div>
    <template>
      <div class="row">
        <div
          v-if="visibleIdentificationDateToField"
          :class="'col-md-' + fieldWidth(PassSectionFieldAliases.IDENTIFICATION_DATE_TO)"
        >
          <identification-date-to-input
            v-model="visitorPersonal.identification_date_to"
            :input-label="fieldTitle(PassSectionFieldAliases.IDENTIFICATION_DATE_TO)"
            :input-hint="fieldHint(PassSectionFieldAliases.IDENTIFICATION_DATE_TO)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :form="form"
            :errors="errors"
            :document-masks="documentMasks"
            :disabled="disabledIdentificationDateTo"
            :min-date="currentMomentDate.clone()"
            :max-date="maxMomentDate.clone()"
            @change="emitChangeDate"
          />
        </div>
        <div
          v-if="visibleIdentificationCodeField"
          :class="'col-md-' + fieldWidth(PassSectionFieldAliases.IDENTIFICATION_CODE)"
        >
          <identification-code-input
            v-model="visitorPersonal.identification_code"
            :input-label="fieldTitle(PassSectionFieldAliases.IDENTIFICATION_CODE)"
            :input-hint="fieldHint(PassSectionFieldAliases.IDENTIFICATION_CODE)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :form="form"
            :errors="errors"
            :disabled="disabledIdentificationCode"
            @change="change"
            @input="inputIdentificationCode"
            @blur="blurIdentificationCode"
          />
        </div>
        <div
          v-if="fieldVisible(PassSectionFieldAliases.IDENTIFICATION_PLACE, PassSectionsEnum.visitors)"
          :class="'col-md-' + fieldWidth(PassSectionFieldAliases.IDENTIFICATION_PLACE)"
        >
          <identification-place-input
            v-model="visitorPersonal.identification_place"
            :input-label="fieldTitle(PassSectionFieldAliases.IDENTIFICATION_PLACE)"
            :input-hint="fieldHint(PassSectionFieldAliases.IDENTIFICATION_PLACE)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :documentMasks="documentMasks"
            :form="form"
            :errors="errors"
            :typeahead="typeaheadIdentificationPlace"
            :select-typeahead="selectIdentificationTypeahead"
            :disabled="disabledIdentificationPlace"
            @change="change"
          />
        </div>
      </div>
      <div class="row">
        <div
          v-if="fieldVisible(PassSectionFieldAliases.ADDRESS, PassSectionsEnum.visitors)"
          :class="'col-md-' + fieldWidth(PassSectionFieldAliases.ADDRESS)"
        >
          <address-input
            v-model="visitorPersonal.address"
            :input-label="fieldTitle(PassSectionFieldAliases.ADDRESS)"
            :input-hint="fieldHint(PassSectionFieldAliases.ADDRESS)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :form="form"
            :errors="errors"
            :typeahead="typeaheadAddress"
            :disabled="disabledAddress"
            @change="change"
            ref="address"
          />
        </div>
      </div>
      <div v-if="visibleActualAddressField" class="row">
        <div :class="'col-md-' + fieldWidth(PassSectionFieldAliases.ACTUAL_ADDRESS)">
          <actual-address-input
            v-model="visitorPersonal.actual_address"
            :input-label="fieldTitle(PassSectionFieldAliases.ACTUAL_ADDRESS)"
            :input-hint="fieldHint(PassSectionFieldAliases.ACTUAL_ADDRESS)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :form="form"
            :errors="errors"
            :typeahead="typeaheadAddress"
            :disabled="disabledActualAddress"
            @change="changeActualAddress"
            ref="address"
          >
            <div slot="after">
              <label class="applicant-helpers flex-label">
                <input
                  v-model="visitorPersonal.actual_address_matches"
                  :disabled="disabledActualAddressMatches"
                  type="checkbox"
                  @change="disableActualAddress"
                />
                &nbsp;
                Совпадает с адресом регистрации
              </label>
            </div>
          </actual-address-input>
        </div>
      </div>
      <div v-if="!isTerminalOrganizationSubject" class="documents-flex-row row">
        <label class="flex-label residence-checkbox col-md-12">
          <input
            v-model="visitorPersonal.require_other_organization"
            :disabled="disabledActualAddressMatches"
            type="checkbox"
          />
          <span class="control-label">Посетитель работает в подрядной организации{{ organizationText }}</span>
        </label>
      </div>
      <div v-if="!isFizOrganizationSubject" class="row">
        <div v-if="visitorPersonal.require_other_organization" class="col-md-4">
          <organization-subject-input
            v-model="visitorPersonal.organization_subject_id"
            :form="form"
            :errors="errors"
            :items="organizationSubjects"
            :nationalities-list="nationalitiesList"
            :organization-subjects-residency="organizationSubjectsResidency"
            :selected-nationality="selectedNationality"
            :disabled="disabledSubject"
            @change="change($event)"
          >
            <template v-slot:selectNationality>
              <b-dropdown
                :id="'organization-subject-input'"
                toggle-class="right-border-radius-unset right-border-none subject-input-dropdown"
                :disabled="disabledSubject"
                ref="dropdown"
                class="subject-input-residency-list"
              >
                <template #button-content>
                  <img
                    v-if="selectedNationality"
                    class="flag_img subject-input-flag"
                    :src="selectedNationalityImage"
                    :alt="selectedNationality.iso2"
                  />
                  <slot name="arrow-icon" :open="nationalityListIsOpen">
                    <span class="vti__dropdown-arrow subject-input-arrow" v-if="isView === false">
                      {{ nationalityListIsOpen ? '▲' : '▼' }}
                    </span>
                  </slot>
                </template>
                <template v-for="(nationality, key) in nationalities">
                  <b-dropdown-item
                    :key="key"
                    :style="{cursor: 'pointer'}"
                    @click="changeOrganizationNationality(nationality)"
                  >
                    <img class="flag_img" :src="iconsPath + nationality.iso2 + '.svg'" alt="" width="20"/>
                    <span style="margin-left: 5px"><strong>{{ nationality.full_name }}</strong></span>
                  </b-dropdown-item>
                </template>
              </b-dropdown>
            </template>
          </organization-subject-input>
        </div>
        <div
          v-if="visibleVisitorOtherOrganizationNameField"
          :class="'col-md-' + fieldWidth(PassSectionFieldAliases.ORGANIZATION_NAME)"
        >
          <visitor-organization-name-input
            v-model="visitorPersonal.organization_name"
            :input-label="fieldTitle(PassSectionFieldAliases.ORGANIZATION_NAME)"
            :input-hint="fieldHint(PassSectionFieldAliases.ORGANIZATION_NAME)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :visitor="visitor"
            :transport-index="transportIndex"
            :form="form"
            :errors="errors"
            :typeahead="typeaheadPersonalOrganizationName"
            :select-typeahead="selectPersonalOrganization"
            :disabled="disabledOrganizationName"
            @change="changeOrganizationName"
            @blur="blurOrganizationName"
            @disable-submit-button="$emit('disable-submit-button')"
            @enable-submit-button="$emit('enable-submit-button')"
          />
        </div>
      </div>
      <div class="row">
        <!--        <div class="col-md-4">-->
        <!--          <visitor-organization-inn-input-->
        <!--            v-model="visitorPersonal.organization_inn"-->
        <!--            :key="visitorIndex"-->
        <!--            :visitor-index="visitorIndex"-->
        <!--            :visitor="visitor"-->
        <!--            :form="form"-->
        <!--            :errors="errors"-->
        <!--            :typeahead="typeaheadPersonalOrganizationInn"-->
        <!--            :select-typeahead="selectPersonalOrganization"-->
        <!--            :disabled="disabledOrganizationInn"-->
        <!--            @change="changeOrganizationInn"-->
        <!--            @blur="blurOrganizationInn"-->
        <!--          />-->
        <!--        </div>-->
        <div
          v-if="fieldVisible(PassSectionFieldAliases.ORGANIZATION_POSITION, PassSectionsEnum.visitors)"
          :class="'col-md-' + fieldWidth(PassSectionFieldAliases.ORGANIZATION_POSITION)"
        >
          <visitor-position-input
            v-model="visitorPersonal.status"
            :input-label="fieldTitle(PassSectionFieldAliases.ORGANIZATION_POSITION)"
            :input-hint="fieldHint(PassSectionFieldAliases.ORGANIZATION_POSITION)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :form="form"
            :errors="errors"
            :disabled="disabledVisitorPosition"
          />
        </div>
        <div
          v-if="fieldVisible(PassSectionFieldAliases.ORGANIZATION_EMAIL, PassSectionsEnum.visitors)"
          :class="'col-md-' + fieldWidth(PassSectionFieldAliases.ORGANIZATION_EMAIL)"
        >
          <visitor-email-input
            v-model="visitorPersonal.email"
            :input-label="fieldTitle(PassSectionFieldAliases.ORGANIZATION_EMAIL)"
            :input-hint="fieldHint(PassSectionFieldAliases.ORGANIZATION_EMAIL)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :form="form"
            :errors="errors"
            :disabled="disabledVisitorPosition"
            @change="change"
          />
        </div>
        <div
          v-if="fieldVisible(PassSectionFieldAliases.PHONE, PassSectionsEnum.visitors)"
          :class="'col-md-' + fieldWidth(PassSectionFieldAliases.PHONE)"
        >
          <visitor-phone-input
            v-model="visitorPersonal.phone"
            :input-label="fieldTitle(PassSectionFieldAliases.PHONE)"
            :input-hint="fieldHint(PassSectionFieldAliases.PHONE)"
            :key="visitorIndex"
            :visitor-index="visitorIndex"
            :visitor="visitor"
            :transport-index="transportIndex"
            :form="form"
            :errors="errors"
            :disabled="disabledPhone"
            @change="change"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AddressInput from '@/common/components/application/form-inputs/visitors/AddressInput.vue'
import { ApiClient } from '@/helpers/api-client/ApiClient'
import { ApplicationStatuses } from '@/enums/ApplicationStatuses'
import AvatarInput from '@/common/components/application/form-inputs/visitors/AvatarInput'
import BirthdayInput from '@/common/components/application/form-inputs/visitors/BirthdayInput.vue'
import FirstNameInput from '@/common/components/application/form-inputs/visitors/FirstNameInput.vue'
import FullNameTitle from '@/common/components/application/form-inputs/visitors/FullNameTitle.vue'
import IdentificationCodeInput from '@/common/components/application/form-inputs/visitors/IdentificationCodeInput.vue'
import IdentificationDateOfInput from '@/common/components/application/form-inputs/visitors/IdentificationDateOfInput.vue'
import IdentificationDateToInput from '@/common/components/application/form-inputs/visitors/IdentificationDateToInput.vue'
import IdentificationDocumentInput from '@/common/components/application/form-inputs/visitors/IdentificationDocumentInput.vue'
import IdentificationNumberInput from '@/common/components/application/form-inputs/visitors/IdentificationNumberInput.vue'
import IdentificationPlaceInput from '@/common/components/application/form-inputs/visitors/IdentificationPlaceInput.vue'
import LastNameInput from '@/common/components/application/form-inputs/visitors/LastNameInput.vue'
import NationalityInput from '@/common/components/application/form-inputs/visitors/NationalityInput.vue'
import PatronymicNameInput from '@/common/components/application/form-inputs/visitors/PatronymicNameInput.vue'
import { PersonalIdentifications } from '@/common/enums/PersonalIdentifications'
import PlacebirthInput from '@/common/components/application/form-inputs/visitors/PlacebirthInput.vue'
import { Typeaheads } from '@/helpers/api-client/Typeaheads'
import { UserRoles } from '@/enums/UserRoles'
import VisitorEmailInput from '@/common/components/application/form-inputs/visitors/VisitorEmailInput.vue'
import VisitorFormMenu from '@/common/components/application/form-blocks/visitors/VisitorFormMenu.vue'
// import VisitorOrganizationInnInput from '@/common/components/application/form-inputs/visitors/VisitorOrganizationInnInput.vue'
import VisitorOrganizationNameInput from '@/common/components/application/form-inputs/visitors/VisitorOrganizationNameInput.vue'
import VisitorPhoneInput from '@/common/components/application/form-inputs/visitors/VisitorPhoneInput.vue'
import VisitorPositionInput from '@/common/components/application/form-inputs/visitors/VisitorPositionInput.vue'
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import forceRerenderMixin from '@/common/mixins/forceRerenderMixin'
import mainMixin from '@/common/mixins/mainMixin'
import moment from 'moment-timezone'
import visitorBlockMixin from '@/common/mixins/application-form/visitorBlockMixin'
import ErrorHelpBlock from '@/common/components/application/ErrorHelpBlock.vue'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import permissionsMixin from '@/common/mixins/PermissionsMixin'
import ActualAddressInput from '@/common/components/application/form-inputs/visitors/ActualAddressInput.vue'
import { PassSectionFieldAliases } from '@/common/enums/PassSectionFieldAliases'
import PassSectionsEnum from '@/common/enums/PassSectionsEnum'
import OrganizationSubjectInput from '@/common/components/application/form-inputs/organization/OrganizationSubjectInput.vue'
import { Logger } from '@/common/helpers/Logger'
import { OrganizationSubjects } from '@/common/enums/OrganizationSubjects'

export default {
  name: 'VisitorPersonalFormBlock',

  components: {
    OrganizationSubjectInput,
    ActualAddressInput,
    ErrorHelpBlock,
    VisitorEmailInput,
    FullNameTitle,
    AddressInput,
    AvatarInput,
    BirthdayInput,
    FirstNameInput,
    IdentificationCodeInput,
    IdentificationDateOfInput,
    IdentificationDateToInput,
    IdentificationDocumentInput,
    IdentificationNumberInput,
    IdentificationPlaceInput,
    LastNameInput,
    NationalityInput,
    PatronymicNameInput,
    PlacebirthInput,
    // VisitorOrganizationInnInput,
    VisitorOrganizationNameInput,
    VisitorPhoneInput,
    VisitorPositionInput,
    VisitorFormMenu
  },

  data: () => ({
    isOrganizationSelectedFromSuggestion: false,
    nationalityListIsOpen: false
  }),

  mixins: [
    applicationFormContextMixin,
    applicationFormMixin,
    forceRerenderMixin,
    visitorBlockMixin,
    mainMixin,
    permissionsMixin
  ],

  model: {
    prop: 'visitorPersonal',
    event: 'change-visitor'
  },

  props: {
    cfgFormFields: {
      type: [Array, Object],
      default: () => []
    },

    cfgMenuVisitor: {
      type: [Object, Array],
      default: () => []
    },

    documentMasks: {
      type: Array,
      default: () => []
    },

    isSingleVisitor: {
      type: Boolean,
      required: true
    },

    nationalitiesList: {
      default: []
    },

    organizationSubjects: {
      type: Array,
      default: () => []
    },

    organizationSubjectsResidency: {
      default: []
    },

    personalIdentifications: {
      type: Array,
      default: () => []
    },

    personalNationalities: {
      type: Array,
      default: () => []
    },

    timezone: {
      type: String,
      default: 'Europe/Moscow'
    },

    transportIndex: {
      type: Number,
      default: null
    },

    typeaheads: {
      type: Object,
      default: () => ({})
    },

    visitor: {
      type: Object,
      default: () => ({})
    },

    visitorIndex: {
      type: Number,
      required: true
    },

    visitorPersonal: {
      type: Object,
      required: true
    }
  },

  computed: {
    OrganizationSubjects() {
      return OrganizationSubjects
    },

    PassSectionsEnum() {
      return PassSectionsEnum
    },

    PassSectionFieldAliases() {
      return PassSectionFieldAliases
    },

    allowAttachAvatar() {
      return this.configuration.allow_attach_avatar === 'all' ||
        this.configuration.allow_attach_avatar === this.form.application.time_type
    },

    allowedNationalities() {
      return this.personalNationalities.filter(nationality => nationality.citizenship === 1)
    },

    calculatedPersonalIdentifications() {
      return this.personalIdentifications.filter((personalIdentification) => {
        if (personalIdentification.id === PersonalIdentifications.SERVICE_IDENTITY) {
          if (this.form.organization.subject_id !== 'gko') {
            return false
          }
        }

        return this.nationalityIdentifications.includes(personalIdentification.id)
      })
    },

    canRemoveVisitor() {
      return this.isSingleVisitor === false
    },

    visibleVisitorOrganizationNameField() {
      return !this.visitorPersonal.require_other_organization &&
      this.fieldVisible(PassSectionFieldAliases.ORGANIZATION_NAME, PassSectionsEnum.visitors)
    },

    visibleVisitorOtherOrganizationNameField() {
      return this.visitorPersonal.require_other_organization &&
        this.fieldVisible(PassSectionFieldAliases.ORGANIZATION_NAME, PassSectionsEnum.visitors)
    },

    currentMomentDate() {
      return moment().tz(this.timezone)
    },

    disabledActualAddress() {
      return Boolean(this.disabledInput) || Boolean(this.visitorPersonal.actual_address_matches)
    },

    disabledActualAddressMatches() {
      return Boolean(this.disabledInput) || this.isView
    },

    disabledAddress() {
      return Boolean(this.disabledInput)
    },

    disabledBirthday() {
      return Boolean(this.disabledInput)
    },

    disabledFirstName() {
      return Boolean(this.disabledInput)
    },

    disabledIdentificationCode() {
      return Boolean(
        this.disabledInput || this.visitorPersonal.identification_id !== PersonalIdentifications.PASSPORT
      )
    },

    disabledIdentificationDateOf() {
      return Boolean(this.disabledInput || this.isServiceIdentity)
    },

    disabledIdentificationDateTo() {
      return Boolean(
        this.disabledInput || this.calculatedPersonalIdentifications.filter(
          (personalIdentification) => personalIdentification.id === this.visitorPersonal.identification_id
        )[0]?.need_expire === 0)
    },

    disabledIdentificationDocument() {
      if (this.calculatedPersonalIdentifications.length === 1) {
        return true
      }

      return Boolean(this.disabledInput)
    },

    disabledIdentificationNumber() {
      return Boolean(this.disabledInput)
    },

    disabledIdentificationPlace() {
      return Boolean(this.disabledInput)
    },

    disabledLastName() {
      return Boolean(this.disabledInput)
    },

    disabledNationality() {
      return Boolean(this.disabledInput || this.form.visitors.length > 1)
    },

    // disabledOrganizationInn() {
    //   return Boolean(this.disabledInput || this.isServiceIdentity || this.isTerminalSubject)
    // },

    disabledOrganizationName() {
      return Boolean(
        this.disabledInput ||
        this.visitorPersonal.identification_id === PersonalIdentifications.SERVICE_IDENTITY ||
        this.isTerminalSubject
      )
    },

    disabledPatronymicMissing() {
      return Boolean(this.disabledInput) || this.isView
    },

    disabledPatronymicName() {
      return Boolean(this.disabledInput) || Boolean(this.visitorPersonal.patronymic_missing)
    },

    disabledPhone() {
      return Boolean(this.disabledInput)
    },

    disabledPlacebirth() {
      return Boolean(this.disabledInput)
    },

    disabledVisitorPosition() {
      return Boolean(this.disabledInput)
    },

    hasErrors() {
      return Boolean(
        this.isView && (this.visitorPersonal.infoBlock || this.getErrorVisitor(this.visitorIndex, 'fullname'))
      )
    },

    inScud() {
      return Number(this.visitor.transports[0]?.inScud) === 1
    },

    isNotCutDriver() {
      if (this.isPassKindTransport) {
        return Number(this.configuration.cut_driver) === 0
      }

      return true
    },

    isServiceIdentity() {
      return this.visitorPersonal.identification_id === PersonalIdentifications.SERVICE_IDENTITY
    },

    isTerminalOrganizationSubject() {
      return this.form.organization.subject_id === OrganizationSubjects.Terminal
    },

    maxMomentDate() {
      return moment(8.64E+15).tz(this.timezone)
    },

    minMomentDate() {
      return moment(-8.64E+15).tz(this.timezone)
    },

    nameAndSurnameSame() {
      return !this.visitorPersonal.patronymic_missing &&
        this.visitorPersonal.fullname_last &&
        this.visitorPersonal.fullname_last.length > 0 &&
        this.visitorPersonal.fullname_patronymic === this.visitorPersonal.fullname_last
    },

    nationalityIdentifications() {
      let masks = this.documentMasks.filter((dockMask) => (
        Number(dockMask.nationality_id) === Number(this.visitorPersonal.nationality_id)
      ) || dockMask.nationality_id === null)

      masks = masks.filter((dockMask) => {
        if (dockMask.nationality_id === null && this.visitorPersonal.nationality_id === 182) {
          let identification = this.personalIdentifications.filter((el) => el.id === dockMask.identification_id)

          return identification[0]?.is_rf === 1
        }

        return true
      })

      return Object.keys(masks).map((key) => masks[key].identification_id)
    },

    showAvatar() {
      if (Number(this.configuration.user_attach_avatar) === 1 && this.allowAttachAvatar) {

        return this.visitor.personal.avatar || this.isNew || this.isDuplicate ||
          this.isDraft || this.hasPermission(PermissionsEnum.canEditVisitorAvatar)
      }

      return false
    },

    selectedNationality() {
      return this.nationalities.find(nationality => nationality.id === this.visitorPersonal.organization_nationality_id) ??
        this.nationalities.find(nationality => nationality.iso2 === 'RU')
    },

    disabledBySystem() {
      return Boolean(this.disabledInput)
    },

    disabledSubject() {
      return Boolean(this.disabledBySystem)
    },

    iconsPath() {
      return process.env.BASE_URL + 'img/icons/countries/'
    },

    nationalities() {
      const nationalitiesIds = [
        ...new Set(this.organizationSubjectsResidency.map((value) => Number(value.nationality_id)))
      ]

      return this.nationalitiesList.filter(nationality => nationalitiesIds.includes(nationality.id))
    },

    organizationText() {
      if (!this.form.organization || !this.form.organization.name || this.form.organization.name === '') {
        return ''
      }

      return ' (не в ' + this.form.organization.name + ')'
    },

    selectedNationalityImage() {
      return this.iconsPath + this.selectedNationality.iso2 + '.svg'
    },

    showAvatarErrorBlock() {
      return this.showAvatar && !this.visitorPersonal.avatar &&
        (this.isPassKindTransport ? this.hasErrorVisitorTransportDriver(this.visitorIndex, this.transportIndex, 'avatar') : this.hasErrorVisitor(this.visitorIndex, 'avatar'))
    },

    showInnClue() {
      return this.visitor.organization_inn
    },

    visibleActualAddressField() {
      return this.fieldVisible(PassSectionFieldAliases.ACTUAL_ADDRESS, PassSectionsEnum.visitors)
    },

    visibleIdentificationDateToField() {
      return this.fieldVisible(PassSectionFieldAliases.IDENTIFICATION_DATE_TO, PassSectionsEnum.visitors) &&
        !this.russianCivilPassportSelected(this.visitor)
    },

    visibleIdentificationCodeField() {
      return this.fieldVisible(PassSectionFieldAliases.IDENTIFICATION_CODE, PassSectionsEnum.visitors) &&
        this.russianCivilPassportSelected(this.visitor)
    },

    visibleCloseButton() {
      return Boolean(this.isView && this.user && this.cfgMenuVisitor.give_access_visitor)
    },

    visitorFormMenuNotEmpty() {
      return this.visibleCloseButton ||
        this.visibleVisitorPrintPassButton ||
        this.visibleVisitorPrintPassPeriodButton ||
        this.visibleVisitorPrintPassPermanentButton ||
        this.visibleVisitorPrintPassPermanentAsOneButton ||
        (
          this.isView && (
            this.visibleVisitorIssuePassButton ||
            this.visibleVisitorIssuePassPeriodButton ||
            this.visibleVisitorSendToSolvoButton ||
            this.visibleVisitorSendToScudButton
          )
        )
    },

    visitorName() {
      const firstName = this.visitorPersonal.fullname_first ?? ''
      const lastName = this.visitorPersonal.fullname_last ?? ''
      const patronymicName = this.visitorPersonal.fullname_patronymic ?? ''

      if (!firstName && !lastName && !patronymicName) {
        return `${this.isPassKindMaterial ? 'Предъявитель №' : 'Посетитель №'}${this.visitorIndex + 1}`
      }

      return `${lastName} ${firstName} ${patronymicName}`
    }
  },

  mounted() {
    if (this.isView || this.isEdit || this.isDraft) {
      this.checkCurrentVisitorApplications()
    }

    if (this.isView && this.form.application.status !== ApplicationStatuses.DRAFT) {
      this.checkBlacklist()
    }
  },

  methods: {
    blurIdentificationCode() {
      this.checkCurrentVisitorApplications()
    },

    blurIdentificationNumber() {
      this.checkCurrentVisitorApplications()
    },

    // blurOrganizationInn($event) {
    //   this.checkInnControlSum(this.visitorIndex)
    //   this.$emit('blur', $event)
    // },

    blurOrganizationName($event) {
      this.isOrganizationSelectedFromSuggestion = false
      if (this.visitorPersonal.require_other_organization) {
        this.disableSubmitButton()
        if (this.visitorPersonal.organization_nationality_id !== 113) {
          let errorMessage = 'Необходмо выбрать организацию из списка.'
          this.errors = { visitors: { [this.visitorIndex]: { personal: { organization_name: errorMessage } } } }
        }
      }
      this.checkInnControlSum(this.visitor)
      this.$emit('blur', $event)
    },

    change() {
      this.$emit('change-visitor', this.visitorPersonal)
    },

    changeActualAddress() {
      if (
        this.visitorPersonal.actual_address.length > 0 &&
        this.visitorPersonal.address === this.visitorPersonal.actual_address
      ) {
        this.visitorPersonal.actual_address_matches = true
        this.disableActualAddress()

        return
      }
      this.change()
    },

    changeBirthday() {
      this.emitChangeDate()
    },

    changeFirstName() {
      this.updateFIO(this.visitorPersonal.fullname_first, items => {
        this.visitorPersonal.gender = items.find(item => item.value === this.visitorPersonal.fullname_first)?.data.gender
      })
      this.change()
    },

    changeIdentificationDateOf() {
      this.emitChangeDate()
    },

    changeIdentificationDateTo() {
      this.emitChangeDate()
    },

    changeLastName() {
      this.updateFIO(this.visitorPersonal.fullname_last, items => {
        this.visitorPersonal.gender = items.find(item => item.value === this.visitorPersonal.fullname_last)?.data.gender
      })
      this.change()
    },

    changeNationality() {
      this.visitorPersonal.identification_id = this.calculatedPersonalIdentifications[0]?.id
      this.visitorPersonal.identification_code = null
      this.visitor.personalUnits = null
      this.$emit('recreate-dropzone')
    },

    // changeOrganizationInn($event) {
    //   this.checkInnControlSum(this.visitorIndex)
    //   this.$emit('change', $event)
    // },

    changeOrganizationName($event) {
      this.checkInnControlSum(this.visitor)
      this.$emit('change', $event)
    },

    changeOrganizationNationality(nationality) {
      const visitorPersonal = Object.assign({}, this.visitorPersonal, { organization_nationality_id: nationality.id })
      Logger.log(`Changed organization nationality ${nationality.id}!`)
      this.$emit('change-visitor', visitorPersonal)
    },

    changePassport() {
      if (this.isServiceIdentity) {
        this.visitorPersonal.identification_date_of = null
      }
    },

    changePatronymic() {
      if (this.visitorPersonal.patronymic_missing === true) {
        this.visitorPersonal.fullname_patronymic = null
      }

      if (this.errors instanceof Object) {
        const errors = this.errors?.visitors?.[this.visitorIndex]?.personal
        const index = errors?.indexOf('fullname_patronymic')
        if (errors && index !== -1) {
          errors.splice(index, 1)
        }
      }
      this.change()
    },

    async checkBlacklist() {
      if (!this.visitorPersonal.id || (
        !this.hasPermission(PermissionsEnum.viewGeneralBlacklist) &&
        !this.hasPermission(PermissionsEnum.viewBlacklist)
      )) {
        return
      }

      await ApiClient.checkBlacklist(this.visitorPersonal.id).then((response) => {
        const responseData = response.data
        const blacklistData = responseData.data

        if (blacklistData.infoBlock) {
          this.$set(this.visitorPersonal, 'infoBlock', blacklistData.infoBlock)
        }

        if (blacklistData.fedSfm) {
          this.$set(this.visitorPersonal, 'fedSfm', blacklistData.fedSfm)
        }
      })
    },

    checkCurrentVisitorApplications() {
      const visitor = this.visitor?.personal
      const application = this.form?.application
      const applicationDto = {
        id: application.id,
        period_of: application.period_of,
        period_to: application.period_to
      }
      const visitorDto = {
        id: visitor.id,
        identification_number: visitor.identification_number,
        fullname_firfst: visitor.fullname_first,
        fullname_last: visitor.fullname_last,
        fullname_patronymic: visitor.fullname_patronymic
      }
      visitor.visitorErr = null
      ApiClient.checkCurrentVisitorApplications({ application: applicationDto, visitor: visitorDto })
        .then((response) => {
          this.$set(this.visitorPersonal, 'visitorErr', response?.data?.message)
        })
    },

    checkIdentificationNumber() {
      let identificationNumber = this.visitorPersonal.identification_number
      let identificationDateOf = this.visitorPersonal.identification_date_of
      if (identificationNumber !== null && identificationNumber.length > 10 && this.russianCivilPassportSelected(this.visitor) && identificationDateOf !== null) {
        let yearInSeries = identificationNumber.substring(2, 4)

        let accordToDateCheck = this.checkPassportSeriesIsAccordToDate(yearInSeries, this.visitorPersonal.identification_date_of)
        let isCorrectCheck = this.checkPassportSeriesIsCorrect(yearInSeries)
        if (accordToDateCheck || isCorrectCheck) {
          let errorMessage = accordToDateCheck ? 'Серия паспорта не соответствует дате выдачи' : 'Неверная серия паспорта'
          if (this.isPassKindTransport) {
            this.errors = { visitors: { 0: { transports: { [this.transportIndex]: { drivers: { [this.visitorIndex]: { personal: { identification_number: errorMessage } } } } } } } }
          } else {
            this.errors = { visitors: { [this.visitorIndex]: { personal: { identification_number: errorMessage } } } }
          }
        }
      }
    },

    async closeVisitor() {
      await ApiClient.changeVisitorAccess({ visitor_id: this.visitorPersonal, appId: this.form.application.id })
        .then((response) => {
          if (response?.data?.status === 'success') {
            const indexOf = this.approveForm.visitors.indexOf(~~this.visitorPersonal.id)

            if (indexOf === -1) {
              this.approveForm.visitors.push(~~this.visitorPersonal.id)
            } else {
              this.approveForm.visitors.splice(indexOf, 1)
            }

            this.$set(this.visitor, 'access', this.visitor.access ? 0 : 1)
          }
        })
    },

    disableActualAddress() {
      if (this.visitorPersonal.actual_address_matches === true) {
        this.visitorPersonal.actual_address = null
      }

      if (this.errors instanceof Object) {
        const errors = this.errors?.visitors?.[this.visitorIndex]?.personal
        const index = errors?.indexOf('actual_address')
        if (errors && index !== -1) {
          errors.splice(index, 1)
        }
      }
      this.change()
    },

    emitChangeDate(subjectChange = false) {
      this.$emit('change-date', subjectChange)
    },

    async inputIdentificationCode() {
      if (this.isView) {
        return
      }

      if (this.visitorPersonal.identification_code && this.visitorPersonal.identification_code.length === 7) {
        await ApiClient.identificationPlaces(this.visitorPersonal.identification_code).then((response) => {
          const responseData = response.data
          let personalUnits = []
          if (responseData.data) {
            personalUnits = responseData.data
          }

          if (personalUnits.length === 1) {
            this.visitorPersonal.identification_place = personalUnits[0]
          } else {
            this.visitor.personalUnits = personalUnits
          }

          this.$set(this.visitor, 'personalUnits', personalUnits)
        })
      }
    },

    removeVisitor() {
      this.$emit('remove-visitor', this.visitorIndex)
    },

    async selectIdentificationTypeahead(selected) {
      if (!(selected instanceof Object)) {
        return
      }

      this.$set(this.visitorPersonal, 'dataSelected', selected.code)
      this.$set(this.visitorPersonal, 'identification_place', selected.name)

      if (this.visitorPersonal.identification_id === PersonalIdentifications.PASSPORT) {
        this.$set(this.visitorPersonal, 'identification_code', selected.code)

        await ApiClient.identificationPlaces(selected.code).then((response) => {
          const responseData = response.data
          let personalUnits = []
          if (responseData.data) {
            personalUnits = responseData.data
          }

          this.$set(this.visitor, 'personalUnits', personalUnits)
        })
      } else {
        this.$set(this.visitorPersonal, 'identification_code', '')
      }
    },

    selectPersonalOrganization(item) {
      if (!item.org_name) {
        return
      }

      this.visitorPersonal.organization_name = item.short_name ?? item.org_name
      this.isOrganizationSelectedFromSuggestion = true
      this.visitorPersonal.organization_inn = item.inn
      if (this.visitorPersonal.require_other_organization) {
        this.enableSubmitButton()
        if (this.visitorPersonal.organization_nationality_id !== 113) {
          this.errors = {}
        }
        if (this.visitorPersonal.organization_inn === this.form.organization.inn) {
          let errorMessage = 'ИНН подрядной организации посетителя не может совпадать ' +
            'с ИНН организации из секции "Заявитель".'
          this.errors = { visitors: { [this.visitorIndex]: { personal: { organization_name: errorMessage } } } }
          this.disableSubmitButton()
        } else {
          this.errors = {}
        }
      }

      this.checkInnControlSum(this.visitor)
    },

    selectTypeaheadFirstName(selected) {
      if (!(selected instanceof Object)) return

      if (selected.dadata) {
        this.visitorPersonal.fullname_first = selected.value
        this.visitorPersonal.gender = selected.data.gender
      }
    },

    selectTypeaheadLastName(selected) {
      if (!(selected instanceof Object)) return

      if (selected.dadata) {
        this.visitorPersonal.fullname_last = selected.value
        this.visitorPersonal.gender = selected.data.gender

        return
      }

      this.visitorPersonal.address = selected.data.address
      this.visitorPersonal.actual_address = selected.data.actual_address
      this.visitorPersonal.actual_address_matches = selected.data.actual_address_matches
      this.visitorPersonal.birthday = selected.data.birthday
      this.visitorPersonal.fullname_first = selected.data.fullname_first
      this.visitorPersonal.fullname_last = selected.data.fullname_last
      this.visitorPersonal.fullname_patronymic = selected.data.fullname_patronymic
      this.visitorPersonal.identification_code = selected.data.identification_code
      this.visitorPersonal.identification_date_of = selected.data.identification_date_of
      this.visitorPersonal.identification_date_to = selected.data.identification_id === PersonalIdentifications.PASSPORT
        ? null
        : selected.data.identification_date_to
      this.visitorPersonal.identification_id = selected.data.identification_id
      this.visitorPersonal.identification_number = selected.data.identification_number
      this.visitorPersonal.identification_place = selected.data.identification_place
      this.visitorPersonal.nationality_id = selected.data.nationality_id
      this.visitorPersonal.organization_name = selected.data.organization_name
      this.visitorPersonal.organization_inn = selected.data.organization_inn
      this.visitorPersonal.placebirth = selected.data.placebirth
      this.visitorPersonal.status = selected.data.status
      this.visitorPersonal.phone = selected.data.phone
      this.visitorPersonal.email = selected.data.email
      this.visitor.files = selected.data.documents
    },

    setTabindex() {
      let hrefs = this.$el.getElementsByTagName('a')
      hrefs.forEach((element) => {
        element.setAttribute('tabindex', '-1')
      })
    },

    async typeaheadAddress(query, done) {
      let entity = 'visitor'
      await this.typeaheadAddresses(query, done, false, entity)
      this.resetTypeaheadActiveIndex(this.$refs.address.$refs.addressRef)
    },

    async typeaheadFirstName(query, done) {
      await this.updateFIO(query, done)
    },

    async typeaheadIdentificationPlace(query, done) {
      if (query.length < 3) {
        return
      }

      done(await Typeaheads.personalUnit(query))
    },

    async typeaheadLastName(query, done) {
      await this.updateFIO(query, done)
    },

    async typeaheadPatronymicName(query, done) {
      await this.updateFIO(query, done)
    },

    // async typeaheadPersonalOrganizationInn(query, done) {
    //   await this.typeaheadOrganizationInn(query, done, false)
    // },

    async typeaheadPersonalOrganizationName(query, done) {
      await this.typeaheadOrganizationName(
        query,
        done,
        this.visitorPersonal.organization_nationality_id,
        this.visitorPersonal.organization_subject_id,
        false
      )
    },

    async typeaheadPlacebirth(query, done) {
      let entity = 'visitor'
      await this.typeaheadAddresses(query, done, true, entity)
      this.resetTypeaheadActiveIndex(this.$refs.placebirth.$refs.addressRef)
    }
  }
}
</script>
